var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0H14.25C14.4489 0 14.6397 0.076091 14.7803 0.211534C14.921 0.346977 15 0.530677 15 0.722222V12.2778C15 12.4693 14.921 12.653 14.7803 12.7885C14.6397 12.9239 14.4489 13 14.25 13H0.75C0.551088 13 0.360322 12.9239 0.21967 12.7885C0.0790176 12.653 0 12.4693 0 12.2778V0.722222C0 0.530677 0.0790176 0.346977 0.21967 0.211534C0.360322 0.076091 0.551088 0 0.75 0ZM13.5 3.06078L7.554 8.18856L1.5 3.04489V11.5556H13.5V3.06078ZM1.88325 1.44444L7.54575 6.25589L13.1265 1.44444H1.88325Z",
    fill: "#64616C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/iconMail.4368afba3c087e7b919a73cc9046c2ea.svg";
export { ForwardRef as ReactComponent };